/**
 * Cray Theme - Products Page Override
 *
 * Custom products listing page for the Cray theme
 */

'use client';

import { Suspense } from 'react';

import { PageLoader } from '@/components/common/SuspenseLoader';
import { useEnhancedTheme } from '@/providers';

/**
 * Cray Theme - Products Page Override
 *
 * Custom products listing page for the Cray theme
 */

/**
 * Cray Theme - Products Page Override
 *
 * Custom products listing page for the Cray theme
 */

/**
 * Cray Theme - Products Page Override
 *
 * Custom products listing page for the Cray theme
 */

/**
 * Cray Theme - Products Page Override
 *
 * Custom products listing page for the Cray theme
 */

/**
 * Cray Theme - Products Page Override
 *
 * Custom products listing page for the Cray theme
 */

/**
 * Cray Theme - Products Page Override
 *
 * Custom products listing page for the Cray theme
 */

/**
 * Cray Theme - Products Page Override
 *
 * Custom products listing page for the Cray theme
 */

/**
 * Cray Theme - Products Page Override
 *
 * Custom products listing page for the Cray theme
 */

/**
 * Cray Theme - Products Page Override
 *
 * Custom products listing page for the Cray theme
 */

export default function CrayProductsPage() {
  return (
    <Suspense fallback={<PageLoader message="Loading products..." />}>
      <CrayProductsContent />
    </Suspense>
  );
}

function CrayProductsContent() {
  const { design } = useEnhancedTheme();

  // Mock product data
  const products = [
    { id: 1, name: 'Premium Headphones', price: 299.99, image: '🎧' },
    { id: 2, name: 'Smart Watch', price: 399.99, image: '⌚' },
    { id: 3, name: 'Laptop Stand', price: 79.99, image: '💻' },
    { id: 4, name: 'Wireless Mouse', price: 49.99, image: '🖱️' },
    { id: 5, name: 'Mechanical Keyboard', price: 159.99, image: '⌨️' },
    { id: 6, name: 'USB-C Hub', price: 89.99, image: '🔌' },
  ];

  return (
    <div
      style={{
        padding: design?.spacing.xl,
        maxWidth: '1400px',
        margin: '0 auto',
      }}
    >
      <div
        style={{
          marginBottom: design?.spacing.xl,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <h1
            style={{
              fontSize: '2.5rem',
              marginBottom: design?.spacing.sm,
              color: design?.colors.text,
            }}
          >
            All Products
          </h1>
          <p
            style={{
              fontSize: '1.1rem',
              color: design?.colors.textSecondary,
            }}
          >
            Discover our complete collection
          </p>
        </div>

        <select
          style={{
            padding: `${design?.spacing.sm} ${design?.spacing.md}`,
            borderRadius: design?.borderRadius.md,
            border: `1px solid ${design?.colors.border}`,
            backgroundColor: design?.colors.surface,
            color: design?.colors.text,
            cursor: 'pointer',
          }}
        >
          <option>Sort by: Featured</option>
          <option>Price: Low to High</option>
          <option>Price: High to Low</option>
          <option>Newest First</option>
          <option>Best Selling</option>
        </select>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: design?.spacing.lg,
        }}
      >
        {products.map((product) => (
          <a
            key={product.id}
            href={`/products/${product.id}`}
            style={{
              backgroundColor: design?.colors.surface,
              borderRadius: design?.borderRadius.lg,
              border: `1px solid ${design?.colors.border}`,
              overflow: 'hidden',
              textDecoration: 'none',
              transition: 'all 0.2s ease',
              cursor: 'pointer',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.1)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <div
              style={{
                height: '200px',
                backgroundColor: design?.colors.surfaceHover,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '4rem',
              }}
            >
              {product.image}
            </div>

            <div style={{ padding: design?.spacing.lg }}>
              <h3
                style={{
                  fontSize: '1.25rem',
                  marginBottom: design?.spacing.sm,
                  color: design?.colors.text,
                }}
              >
                {product.name}
              </h3>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <span
                  style={{
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                    color: design?.colors.primary,
                  }}
                >
                  ${product.price}
                </span>

                <button
                  style={{
                    padding: `${design?.spacing.sm} ${design?.spacing.md}`,
                    backgroundColor: design?.colors.primary,
                    color: '#fff',
                    border: 'none',
                    borderRadius: design?.borderRadius.md,
                    cursor: 'pointer',
                    fontSize: '0.9rem',
                    fontWeight: '500',
                  }}
                >
                  Add to Cart
                </button>
              </div>

              <div
                style={{
                  marginTop: design?.spacing.sm,
                  fontSize: '0.85rem',
                  color: design?.colors.textSecondary,
                }}
              >
                ⭐⭐⭐⭐⭐ (42 reviews)
              </div>
            </div>
          </a>
        ))}
      </div>

      <div
        style={{
          marginTop: design?.spacing.xl,
          padding: design?.spacing.lg,
          backgroundColor: design?.colors.surfaceHover,
          borderRadius: design?.borderRadius.md,
          textAlign: 'center',
        }}
      >
        <p
          style={{
            color: design?.colors.textSecondary,
            fontSize: '0.9rem',
          }}
        >
          🎨 This page is rendered by the <strong>Cray theme</strong> override
        </p>
      </div>
    </div>
  );
}
